import { useMapType } from 'hooks/maps.hooks';
import SearchBoxAutocomplete from '../search-box-autocomplete/search-box-autocomplete.component';
import AddressAutocompleteNew from './address-autocomplete-new.component';
import AddressAutocompleteOld from './address-autocomplete.component';
import { useGateValue } from '@statsig/react-bindings';

const AddressAutocompleteGate = props => {
  const { isMapbox, isLoading } = useMapType();
  const value = useGateValue('google-places-web-upgrade');

  if (isLoading) {
    return null;
  }

  if (isMapbox) {
    return <SearchBoxAutocomplete {...props} />;
  } else {
    return value ? (
      <AddressAutocompleteNew {...props} />
    ) : (
      <AddressAutocompleteOld {...props} />
    );
  }
};
export default AddressAutocompleteGate;
